// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AcoesMarketing_GaleriaFotoInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/** Nested item of AcoesMarketing_SalvarInput::$galeria — same shape as the site units' gallery. */
import { registerContract } from './validate'

export interface AcoesMarketing_GaleriaFotoInput {
foto_url: string
foto_alt?: string
}

registerContract('AcoesMarketing_GaleriaFotoInput', {
  foto_url: { type: 'string',  required: true },
  foto_alt: { type: 'string',  required: false },
})
